import { Component, ViewChild, Output } from '@angular/core';
import { SelectItem } from 'primeng/api';
import { AccountingPackageService } from '../shared/accounting-package/accounting-package.service';
import { AccountingPackageJournalEntry } from '../shared/transaction/dto/accounting-package-journal-entry.dto';
import { FinancialServiceService } from '../shared/financial.service';
import { TransactionSearchV2Dto } from '../shared/transaction/dto/transaction-searchv2.dto';
import { TransactionTypeEnum } from '../shared/transaction/dto/transaction-type.enum';
import { DetailedTransactionsGridComponent } from './detailed-transactions-grid/detailed-transactions-grid.component';
import { JournalEntriesGridComponent } from './journal-entries-grid/journal-entries-grid.component';
import { PagedResult, PagedResultGeneric } from 'src/app/shared';
import { PostedTransactionDto } from '../shared/transaction/dto/posted-transaction.dto';

@Component({
  selector: 'wl-posted-batches',
  templateUrl: './posted-batches.component.html',
  styleUrls: ['./posted-batches.component.less'],
    standalone: false
})
export class PostedBatchesComponent {
  @ViewChild('transactionsGrid') transactionsGrid: DetailedTransactionsGridComponent;
  @ViewChild('journalsGrid') journalsGrid: JournalEntriesGridComponent;

  batchesShown: string = 'detailed-transactions';
  searchDto: TransactionSearchV2Dto = { PageNumber: 1, PageSize: 20 } as TransactionSearchV2Dto;
  accountingPackages: SelectItem[] = [];
  transactionTypes: SelectItem[] = [
    { label: 'Invoice Line Item', value: TransactionTypeEnum.InvoiceLineItem },
    { label: 'Payments', value: TransactionTypeEnum.Payments },
    { label: 'Adjustments', value: TransactionTypeEnum.Adjustments },
    { label: 'Unapplied Payments', value: TransactionTypeEnum.UnappliedPayments },
  ];
  firstSearchRun: boolean = false;

  constructor(private _financialService: FinancialServiceService) {}

  ngOnInit() {
    this._financialService.getAccountingPackages().then((packages) => {
      this.accountingPackages = packages.map<SelectItem>((x) => {
        return { label: x.Name, value: x.AccountingPackageID };
      });
    });
  }

  runSearch() {
    this.firstSearchRun = true;
    if (this.batchesShown === 'detailed-transactions') {
      this.transactionsGrid.search();
    }

    if (this.batchesShown == 'journal-entries') {
      this.journalsGrid.search();
    }
  }

  clearSearch() {
    this.searchDto = { PageSize: 20, PageNumber: 1 } as TransactionSearchV2Dto;
    if (this.journalsGrid != null) {
      this.journalsGrid.searchResult = {} as PagedResultGeneric<AccountingPackageJournalEntry>;
    }
    if (this.transactionsGrid != null) {
      this.transactionsGrid.searchResult = {} as PagedResultGeneric<PostedTransactionDto>;
    }
  }
}
